module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    },
    slot: "left"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doSignup(_vm.user)
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('info.create_account')))]), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.firstname'),
      "type": "text",
      "tabindex": "0",
      "autofocus": "",
      "required": ""
    },
    model: {
      value: (_vm.user.nombre),
      callback: function($$v) {
        _vm.$set(_vm.user, "nombre", $$v)
      },
      expression: "user.nombre"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.lastname'),
      "type": "text",
      "tabindex": "1",
      "required": ""
    },
    model: {
      value: (_vm.user.apellido),
      callback: function($$v) {
        _vm.$set(_vm.user, "apellido", $$v)
      },
      expression: "user.apellido"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.email'),
      "type": "email",
      "tabindex": "2",
      "required": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.password'),
      "type": "password",
      "tabindex": "3",
      "required": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.repeat_password'),
      "type": "password",
      "tabindex": "3",
      "required": ""
    },
    model: {
      value: (_vm.user.repeat_password),
      callback: function($$v) {
        _vm.$set(_vm.user, "repeat_password", $$v)
      },
      expression: "user.repeat_password"
    }
  }), _vm._v(" "), _c('mt-switch', {
    model: {
      value: (_vm.user.eresasistente),
      callback: function($$v) {
        _vm.$set(_vm.user, "eresasistente", $$v)
      },
      expression: "user.eresasistente"
    }
  }, [_vm._v(_vm._s(_vm.$t('info.reservation_for_other')))]), _vm._v(" "), _c('mt-button', {
    staticClass: "orange",
    attrs: {
      "size": "large",
      "type": "primary",
      "tabindex": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t("buttons.creating_account")))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('info.terms_and_conditions')) + " "), _c('a', {
    attrs: {
      "href": _vm.linkTerms
    }
  }, [_vm._v(_vm._s(_vm.$t('info.terms_and_conditions2')))]), _vm._v(" " + _vm._s(_vm.$t('info.terms_and_conditions3')) + " "), _c('a', {
    attrs: {
      "href": _vm.linkPolicies
    }
  }, [_vm._v(_vm._s(_vm.$t('info.terms_and_conditions4')))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": require("../../../assets/images/logo.png"),
      "onerror": "this.onerror=null; this.src='logo.png'"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7820816!./src/app/pages/signup/index.html
// module id = 762
// module chunks = 18